import React from "react";
import Project from "../components/project";
import style from "../styles/projects.module.css";
import Reveal from "../components/reveal";
import { projects } from "../data/profile";

const Projects = () => (
  <section id="projects" className={`sectionShell ${style.projects}`}>
    <div className="sectionInner">
      <Reveal dir="up" amount={0.4}>
        <h2 className="sectionHeading" data-outline="Projects">
          Projects
        </h2>
      </Reveal>

      <div className={style.grid}>
        {projects.map((ele, ind) => (
          <Project key={ele.id} {...ele} ind={ind} />
        ))}
      </div>
    </div>
  </section>
);

export default Projects;
